export default "__VITE_ASSET__CdoDuHVV__";